import { shortenNumber, theme } from '../..';
import { BarDatum, BarTooltipProps, ComputedDatum } from '@nivo/bar';

export const getTooltip =
  (totalCnt: number) =>
  ({ id, indexValue, value }: BarTooltipProps<BarDatum>) => {
    const shortenValue = shortenNumber(value, 2);

    const shortenPercentage = shortenNumber((value / totalCnt) * 100, 2);
    const label = id === 'remainder' ? 'Other' : indexValue;

    return (
      <div
        style={{
          padding: 8,
          background: theme.tooltip.container.background,
          fontSize: '12px',
        }}
      >
        {label}: <strong>{shortenValue}</strong> (
        <strong>{shortenPercentage}%</strong>)
      </div>
    );
  };

export const getColor = (data: ComputedDatum<BarDatum>) => {
  const categoriesColor = {
    remainder: '#6C727F60',
    value: theme.tokens.emerald[700],
  };
  if (data.id === 'remainder') {
    return categoriesColor.remainder;
  }
  return categoriesColor.value;
};

export const getLabel =
  (total_count: number) => (data: ComputedDatum<BarDatum>) => {
    if (String(data.id) === 'remainder') {
      return '';
    }

    const percentage = data.value ? (data.value / total_count) * 100 : 0;

    return String(`${shortenNumber(percentage, 2)}%`);
  };